import script from "./badgesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./badgesSection.vue?vue&type=script&setup=true&lang=js"

import "./badgesSection.vue?vue&type=style&index=0&id=0b6fb2d3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b6fb2d3"]])

export default __exports__